module.exports = __webpack_public_path__ + "img/equityIcon6.d66b9897.png";